import NavigationItem from '@/lib/transfer-objects/NavigationItem'

const commits = {
  UPDATE_TITLE: 'update-title',
  UPDATE_BACK: 'update-back',
  UPDATE_NAVIGATION: 'update-navigation'
}

export default {
  namespaced: true,
  state: {
    title: undefined,
    image: undefined,
    back: undefined,
    navigation: []
  },
  mutations: {
    [commits.UPDATE_BACK] (state, payload) {
      if (payload.back !== undefined && !(payload.back instanceof NavigationItem)) {
        throw new Error('back must be a NavigationItem instance')
      }
      state.back = payload.back
    },
    [commits.UPDATE_TITLE] (state, payload) {
      // if (payload.back !== undefined && !(payload.back instanceof NavigationItem)) {
      //   throw new Error('back must be a NavigationItem instance')
      // }

      state.title = payload.title
      state.image = payload.image
      // state.back = payload.back
    },
    [commits.UPDATE_NAVIGATION] (state, navigation) {
      if (!(navigation instanceof Array)) {
        throw new Error('Navigation must be an array !')
      }

      navigation.forEach(item => {
        if (!(item instanceof NavigationItem)) {
          throw new Error('Navigation items must be NavigationItem instances !')
        }
      })

      state.navigation = navigation
    }
  },
  getters: {
    title (state) {
      return state.title
    },
    image (state) {
      return state.image
    },
    back (state) {
      return state.back
    },
    navigation (state) {
      return state.navigation
    }
  },
  actions: {
    setHeaderTitle ({ commit }, payload) {
      if (typeof payload === 'string') {
        commit(commits.UPDATE_TITLE, {title: payload})
        return
      }
      commit(commits.UPDATE_TITLE, payload)
    },
    setHeaderBack ({ commit }, payload) {
      commit(commits.UPDATE_BACK, payload)
    },
    setHeaderNavigation ({ commit }, payload) {
      commit(commits.UPDATE_NAVIGATION, payload)
    }
  }
}

export {commits}



// WEBPACK FOOTER //
// ./src/store/header-store.js